export default __webpack_public_path__ + "static/media/pic2.64e744a3.jpg";